import { useNavigate } from 'react-router-dom';

export const HeaderInfo = ({
  children,
  title,
  subtitle,
  backUrl,
  actionButton,
}: {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  backUrl?: string;
  actionButton?: React.ReactNode;
}) => {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full p-4 md:p-10">
      <div className="flex flex-col justify-between lg:flex-row lg:items-center">
        <div>
          <div className="flex items-center">
            {backUrl && (
              <img
                width={22}
                height={22}
                src="/icons/back_arrow.svg"
                alt="arrow-left"
                className="mr-2 shrink-0 cursor-pointer md:hidden"
                onClick={() => navigate(backUrl)}
              />
            )}
            {title ? (
              <h1 className="text-lg font-bold md:text-2xl">{title}</h1>
            ) : (
              <div className="h-7 md:h-8" />
            )}
          </div>
          {subtitle && (
            <h3 className="mt-2 text-base md:text-lg">{subtitle}</h3>
          )}
        </div>
        <div className="mt-2 lg:mt-0">{actionButton}</div>
      </div>

      {children}
    </div>
  );
};
